import { render, staticRenderFns } from "./CalendarEditorV2.vue?vue&type=template&id=23ceb8a8&scoped=true"
import script from "./CalendarEditorV2.vue?vue&type=script&lang=js"
export * from "./CalendarEditorV2.vue?vue&type=script&lang=js"
import style0 from "./CalendarEditorV2.vue?vue&type=style&index=0&id=23ceb8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ceb8a8",
  null
  
)

export default component.exports